import { MessageScreen } from '@/components/MessageScreen/MessageScreen';
import { useConfig } from '@/hooks/useConfig/useConfig';
import { useAirKeyTracePageView } from '@/utils/airKeyTrace';

// TODO: Same as failedVerification but different images, see if we can simplify
export const NetworkError = () => {
  const { content, locale } = useConfig();
  useAirKeyTracePageView('network_error');

  return (
    <MessageScreen
      iconPath={`${content.config.urlBase}${content.networkError.img.src}`}
      iconSize={content.networkError.img.width}
      title={content.networkError.title[locale]}
      titleSize={25}
      body={content.networkError.description[locale]}
    />
  );
};
